import { motion } from "framer-motion";
import React from "react";


export const SkillCard = ({ name, icon, color }) => (
    <div className="flex flex-col items-center m-2">
      <motion.div
        className="  sm:p-5 p-3  text-center"
       
        transition={{ type: "spring", stiffness: 300 }}
      >
        {React.cloneElement(icon, { color })}
      </motion.div>
      <p className="text-white/90 font-thin mt-2 text-sm">{name}</p>
    </div>
  );
  